<div class="layout-sidebar" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
    <div class="sidebar-header">
        <a [routerLink]="['/']" class="app-logo">
            <img 
                [src]="imgSrcComputed()" 
                alt="Clubside" 
                class="transition-all duration-300"
                [class.app-logo-small]="showSmallImageComputed()"
                [class.app-logo-normal]="!showSmallImageComputed()"
                [ngStyle]="{ 
                    width: showSmallImageComputed() 
                        ? (layoutService.isReveal() ? '25px' : '60px') 
                        : '120px' 
                }"
            />
        </a>
        <button class="layout-sidebar-anchor p-link z-2" type="button" (click)="anchor()"></button>
    </div>

    <div #menuContainer class="layout-menu-container">
        <app-menu></app-menu>
    </div>
</div>